import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  HandlersProjectResponse,
  useLazyGetApiProjectsQuery,
} from '../../app/athenaApiGen';

type TProjectFilterProps = {
  handleChange: (id?: string | null, title?: string | null) => void;
  programId?: string;
  projectId?: string;
  required?: boolean;
  customWidth?: string;
  disabled?: boolean;
  label?: string;
};

const ProjectFilter = (props: TProjectFilterProps) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<HandlersProjectResponse[]>([]);
  const [queryProjects, { isFetching: isLoading }] =
    useLazyGetApiProjectsQuery();

  const handleOpen = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        const data = await queryProjects({
          page: 0,
          pageSize: 100,
          programId: props.programId,
        }).unwrap();
        setOptions((data.projects ?? []).filter((p) => p.workflowState === "Internally Approved"));
      } catch (err) {
        console.log(err);
      }
    })();
  }, [queryProjects]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: props.customWidth ? '0 0 auto' : 1,
        width: props.customWidth,
      }}
    >
      <Autocomplete
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        disabled={props.disabled}
        isOptionEqualToValue={(option, value) => option.title === value.title}
        getOptionLabel={(option) => option.title ?? ''}
        options={options}
        loading={isLoading}
        value={options.find((opt) => opt.projectId === props.projectId) || null}
        onChange={(_, newValue) => {
          props.handleChange(
            newValue ? newValue?.projectId : null,
            newValue ? newValue?.title : null,
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label ?? 'Project'}
            required={props.required}
            size="small"
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default ProjectFilter;
